import { cn } from '../../lib/cn';

export default function SkillMeter({
  name,
  value = 0,
  max = 100,
  className,
  showPercentage = true,
  size = 'md',
}) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  const sizes = {
    sm: { bar: 'h-1.5', text: 'text-xs' },
    md: { bar: 'h-2', text: 'text-sm' },
    lg: { bar: 'h-3', text: 'text-base' },
  };

  const getColorClass = (pct) => {
    if (pct >= 80) return 'bg-green-500';
    if (pct >= 50) return 'bg-gray-700 dark:bg-gray-300';
    return 'bg-gray-400';
  };

  return (
    <div className={cn('w-full', className)}>
      <div className="flex items-center justify-between mb-1.5">
        <span className={cn('font-medium text-gray-900 dark:text-white', sizes[size].text)}>
          {name}
        </span>
        {showPercentage && (
          <span className={cn('text-gray-500 dark:text-gray-400', sizes[size].text)}>
            {Math.round(percentage)}%
          </span>
        )}
      </div>
      <div
        className={cn(
          'w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden',
          sizes[size].bar
        )}
      >
        <div
          className={cn(
            'h-full rounded-full transition-all duration-500 ease-out',
            getColorClass(percentage)
          )}
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={max}
          aria-label={`${name}: ${Math.round(percentage)}%`}
        />
      </div>
    </div>
  );
}

export function SkillMeterCompact({ name, value = 0, className }) {
  const percentage = Math.min(Math.max(value, 0), 100);

  const getColorClass = (pct) => {
    if (pct >= 80) return 'bg-green-500';
    if (pct >= 50) return 'bg-gray-700 dark:bg-gray-300';
    return 'bg-gray-400';
  };

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-gray-100 dark:bg-gray-700',
        className
      )}
    >
      <span className="text-sm font-medium text-gray-700 dark:text-gray-200">{name}</span>
      <div className="w-16 h-1.5 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden">
        <div
          className={cn(
            'h-full rounded-full transition-all duration-300',
            getColorClass(percentage)
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="text-xs text-gray-500 dark:text-gray-400 w-8">{Math.round(percentage)}%</span>
    </div>
  );
}
